import { useSelector } from 'react-redux';
import { agentTypeToSenderType } from 'conversations-message-history/senders/operators/agentTypeToSenderType';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getEmail, getFirstName, getLastName } from 'conversations-message-history/senders/operators/getters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { getCurrentThreadInboxId } from '../../thread-details/selectors/getCurrentThreadInboxId';
import { getAuditAgentId, getAuditAgentType, getDestinationInbox
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-message-history/inbox-update-message/operators/inboxUpdateMessageGetters';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import formatName from 'I18n/utils/formatName';
import { fetchInboxName } from 'conversations-thread-data/move-to-inbox/public/clients';
import { useEffect, useState } from 'react';
import SystemMessage from 'conversations-inbox-message-history/system-message/SystemMessage';
import { chooseInboxChangeMessage } from '../operators/chooseInboxChangeMessage';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { InboxIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreadInboxUpdateSystemMessage = ({
  message,
  senders,
  userId,
  ungatedForThreadMessagesUIImprovements
}) => {
  const currentInboxId = useSelector(getCurrentThreadInboxId);
  const destinationInboxId = getDestinationInbox(message);
  const [destinationInboxName, setDestinationInboxName] = useState();
  useEffect(() => {
    if (currentInboxId !== destinationInboxId) {
      fetchInboxName(destinationInboxId).then(name => setDestinationInboxName(name)).catch(() => setDestinationInboxName(undefined));
    }
  }, [currentInboxId, destinationInboxId]);
  const auditAgentId = getAuditAgentId(message);
  const auditAgentType = agentTypeToSenderType(getAuditAgentType(message));
  const auditAsyncSender = findSender(auditAgentId, auditAgentType, senders);
  const isLoading = isSenderLoading(auditAsyncSender);
  const auditAgentSender = auditAsyncSender && getData(auditAsyncSender);
  const auditAgentName = formatName({
    firstName: auditAgentSender && getFirstName(auditAgentSender),
    lastName: auditAgentSender && getLastName(auditAgentSender),
    email: auditAgentSender && getEmail(auditAgentSender)
  });
  const timestamp = getTimestamp(message);
  if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      inlineSize: "200px",
      use: "on-shade"
    });
  }
  return /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: timestamp,
    description: chooseInboxChangeMessage({
      activeAgentId: userId,
      auditAgentSender,
      auditAgentName,
      currentInboxId,
      destinationInboxId,
      destinationInboxName
    }),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      icon: InboxIcon,
      size: "500"
    }),
    ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
  });
};
ThreadInboxUpdateSystemMessage.displayName = 'ThreadInboxUpdateSystemMessage';
export default ThreadInboxUpdateSystemMessage;